import { toaster } from "../components/toaster";
import { DefaultService } from "../generated";
import { useMutation, useQueryClient } from "@tanstack/react-query";

export const useInvoiceSend = () => {
  const queryClient = useQueryClient();
  return useMutation({
    mutationKey: ["invoiceSend"],
    mutationFn: DefaultService.fakturInvoicesViewsInvoiceSend,
    onSuccess: () => {
      toaster.success({ title: "Fakturaer er lagt til utsending" });
      queryClient.invalidateQueries({ queryKey: ["invoiceList"] });
    },
  });
};
